import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-lg fixed w-full top-0 z-50">
      <div className="container mx-auto px-3 sm:px-4 py-3 sm:py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2 sm:space-x-3">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-accent rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-plug-line text-white text-lg sm:text-xl"></i>
            </div>
            <div>
              <h1 className="text-lg sm:text-2xl font-bold text-[#333333] tracking-wide" style={{ fontFamily: '"Inter", "Roboto", sans-serif' }}>
                ZAID ENTERPRISE
              </h1>
              <p className="text-xs sm:text-sm text-gray-600">Industrial Power Solutions</p>
            </div>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-[#333333] hover:text-primary font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-[#333333] hover:text-primary font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-[#333333] hover:text-primary font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('products')}
              className="text-[#333333] hover:text-primary font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Products
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-accent text-white px-6 py-2 rounded-lg hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact Us
            </button>
          </nav>

          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-[#333333]`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-4 py-4 border-t border-gray-200 animate-fadeIn">
            <div className="flex flex-col space-y-3">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-[#333333] hover:text-primary font-medium transition-colors cursor-pointer text-left whitespace-nowrap py-2 px-3 rounded-lg hover:bg-gray-50"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-[#333333] hover:text-primary font-medium transition-colors cursor-pointer text-left whitespace-nowrap py-2 px-3 rounded-lg hover:bg-gray-50"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-[#333333] hover:text-primary font-medium transition-colors cursor-pointer text-left whitespace-nowrap py-2 px-3 rounded-lg hover:bg-gray-50"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('products')}
                className="text-[#333333] hover:text-primary font-medium transition-colors cursor-pointer text-left whitespace-nowrap py-2 px-3 rounded-lg hover:bg-gray-50"
              >
                Products
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-accent text-white px-6 py-3 rounded-lg hover:bg-accent-600 transition-colors cursor-pointer text-center whitespace-nowrap font-semibold"
              >
                Contact Us
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}